import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as actions from "../../actions/ordersAction";
import * as compressionAction from '../../actions/compressionAction';
import { bindActionCreators } from 'redux';
import ProductCardComponent from "./ProductCardComponent";
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as symbols from "../../operations/symbols";
import LoaderComponent from '../core/LoaderComponent';
import Search from "sushiweb/Icons/all/Search";
import Cross from "sushiweb/Icons/all/Cross";
import Input from "sushiweb/InputTypes/Input";

import { round, validEmail } from '../../operations/operations';
import { fetchAppConfig } from './../../actions/appConfigActions';
import PictureModeModal from '../core/PictureModeModal';

class OrderProductsComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      products: [],
      hasNoSearchResult: false,
      reasons: [],
      issues: {},
      totalItems: 0,
      issueItems: 0,
      isOpen: [],
      allReset: true,
      toggleDownWrapper: false, //toggle it with isOpen
      showInvoiceModal: false,
      productCod: {},
      showCodModal: false,
      da_collected_amount:'',
      da_amount_error: ''
    }
  }

  setIssue = (orderProductId, issue) => {
    var issues = this.state.issues;
    issues[[orderProductId]] = issue;
    this.setState({ issues, issueItems: Object.keys(issues).length })
  };


  deleteIssue = (orderProductId) => {
    var issues = this.state.issues;
    delete issues[[orderProductId]];
    this.setState({ issues, issueItems: Object.keys(issues).length })
  };

  setSearchVal(e) {
    const { products } = this.state;
    if (e.target.value != '') {
      const tempProducts = this.props.orders.orderProducts.filter((ele, index) => {
        if (ele.skuName.toLowerCase().includes(e.target.value.toLowerCase())) {
          return ele
        }
      });
      this.setState({ products: tempProducts, hasNoSearchResult: false })
    } else {
      this.setState({
        products: this.props.orders.orderProducts,
        hasNoSearchResult: true
      })
    }
  }

  componentDidMount() {
    const orderId = this.props.match.params.id;
    this.props.actions.getAllIssueReasons('productIssue');
    this.props.actions.getOrderProducts(orderId);
    this.props.actions.resetCompressedImagesAction();
    // this.props.actions.getOrderDetails(orderId);

    const params = {
      entityId: parseInt(orderId),
      eventName: 'verify_products_start'
    }
    if (this.props.isAssetTrackingEnabled === "") {
      this.props.actions.fetchAppConfig();
    }
    if (this.props.orders && !this.props.orders.orderDetails) {
      this.props.actions.getOrderDetails(orderId);
    }
    this.props.actions.sendEvent(params);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { getAllIssueReasonsStatus, orders, getOrderProductsStatus, updateDACollectedAmountStatus, updateDACollectedAmountError} = this.props;
    if (orders.reasons && getAllIssueReasonsStatus !== prevProps.getAllIssueReasonsStatus && getAllIssueReasonsStatus === symbols.STATUS_DONE) {
      var reasons = orders.reasons.map((ele) => ({ key: ele.id, value: ele.name, sendValue: ele.id, rules: ele.rules }));
      reasons.push({ key: 0, value: 'None', sendValue: 0, rules: null });
      this.setState({ reasons })
    }
    if (orders.orderProducts && getOrderProductsStatus !== prevProps.getOrderProductsStatus && getOrderProductsStatus === symbols.STATUS_DONE) {
      orders.orderProducts.forEach((ele) => {
        if (ele.issue !== null && ele.issue.quantityDelivered < ele.quantityDispatched) { this.setIssue(ele.id, ele.issue) }
      });
      
      const isOpen = [];
      for (let i in orders.orderProducts) {
        isOpen[orders.orderProducts[i].id] = false;
      }

      this.setState({products: orders.orderProducts, totalItems: orders.orderProducts.length, isOpen}, () => { 
        // this.setState({da_collected_amount: this.calculateCOD()})
      });
    }


    if (updateDACollectedAmountStatus != prevProps.updateDACollectedAmountStatus && updateDACollectedAmountStatus === symbols.STATUS_DONE) {
     this.goToAssets();
    }

    if (updateDACollectedAmountStatus === symbols.STATUS_FAIL && updateDACollectedAmountError != prevProps.updateDACollectedAmountError) {
      this.setState({da_amount_error: updateDACollectedAmountError})
    }

  }

  goToAssets(){
    const id = this.props.match.params.id;
    const { isAssetTrackingEnabled } = this.props;
    if (isAssetTrackingEnabled) {
      this.props.history.push({
        pathname: '/order/' + id + "/assetTrack",
        state: { id, orderNumber: this.props.location.state.orderNumber }
      })
    } else {
      this.goToNextScreen();
    }
  }

  updateDACollectedAmount(value){
    this.setState({
      da_amount_error:'',
      da_collected_amount: value
    })
  }

  handleOnSubmit(cod = false) {
    if (cod) {
      this.setState({ showCodModal: true });
    } else {
     this.goToAssets();
    }
  }

  updateCollectedAmount(){
    var toBeCollected = this.calculateCOD();
    var minAmtAllowed = toBeCollected - (toBeCollected%5)
    var maxAmtAllowed = toBeCollected + (100 - (toBeCollected%100))

    if (isNaN(this.state.da_collected_amount) || this.state.da_collected_amount < minAmtAllowed || this.state.da_collected_amount > maxAmtAllowed) {
      this.setState({da_amount_error: `Amount collected should be between \u20B9 ${minAmtAllowed} - \u20B9 ${maxAmtAllowed}`})
      return
    }
    
    //make a requst to backend
    let payload = {
      orderId: Number(this.props.match.params.id),
      daCollectedAmount:  Number(this.state.da_collected_amount),
      outstandingAmount: this.calculateCOD()
    }
    this.props.actions.updateDaCollectedAmount(payload);
  }

  goToNextScreen = () => {
    const orderId = this.props.match.params.id;
    let invoiceImages = this.props.orders.orderDetails.images.reduce((acc, ele) => {
      if (ele.entityType === 'invoice') {
        acc.push(ele)
      }
      return acc
    }, []);
    if (invoiceImages.length === 0) {
      this.setState({ showInvoiceModal: true })
    } else {
      this.props.history.push({
        pathname: '/order/' + orderId + "/invoice",
        state: { id: orderId, images: invoiceImages, orderNumber: this.props.location.state.orderNumber }
      })
    }
  }

  setIsOpen(id) {
    let isOpen = [...this.state.isOpen];
    if (isOpen[id] == true) {
      isOpen[id] = false;
      this.setState({ allReset: false })
    } else {
      for (let i in isOpen) {
        isOpen[i] = false;
      }
      isOpen[id] = true;
    }
    this.setState({ allReset: false })
    this.setState({ isOpen, toggleDownWrapper: true })
  }

  setClose() {
    let isOpen = [...this.state.isOpen];
    for (let i in isOpen) {
      isOpen[i] = false;
    }
    this.setState({ allReset: true })
    this.setState({ isOpen, toggleDownWrapper: false })
  }

  closePictureModeModal() {
    this.setState({ showInvoiceModal: false })
  }

  getDeliveredQty(quantity, id) {
    this.setState((prevState) => ({
      productCod: {
        ...prevState.productCod,
        [id]: quantity
      }
    }))
  }
 
  calculateCOD = () => {
    let cod = 0;
    let discountedQuantityAmt =0;
    let normalQuantityAmt =0;
    const { products } = this.state;
    for (let product of products) {
      if (this.state.productCod[product.id] >= 0) {
        if (product.discounted_quantity > this.state.productCod[product.id]){
          discountedQuantityAmt =round((product.discounted_price_per_unit  * (1 + (product.gstRate + product.cessRate) / 100) * (Number(product.discounted_quantity) - this.state.productCod[product.id])),2)
          normalQuantityAmt =round((product.pricePerUnit * (1 + (product.gstRate + product.cessRate) / 100) * (Number(product.quantityDispatched) - Number(product.discounted_quantity))) ,2)
          cod = cod + normalQuantityAmt+ discountedQuantityAmt;
          }
          else{
            normalQuantityAmt = round(product.pricePerUnit * (1 + (product.gstRate + product.cessRate) / 100) * (Number(product.quantityDispatched) - this.state.productCod[product.id]),2)
          cod = cod + normalQuantityAmt;
          }
      } else if (!this.state.productCod[product.id] && product.issue) {
        if (product.discounted_quantity > product.issue.quantityDelivered){
          discountedQuantityAmt = round((product.discounted_price_per_unit  * (1 + (product.gstRate + product.cessRate) / 100)* (Number(product.discounted_quantity) - Number(product.issue.quantityDelivered))),2)
         normalQuantityAmt = round((product.pricePerUnit * (1 + (product.gstRate + product.cessRate) / 100) * (Number(product.quantityDispatched) - Number(product.discounted_quantity))),2)
          cod = cod + normalQuantityAmt+ discountedQuantityAmt;
        }
        else{
          normalQuantityAmt =round(product.pricePerUnit * (1 + (product.gstRate + product.cessRate) / 100) * (Number(product.quantityDispatched) - Number(product.issue.quantityDelivered)),2)
        cod = cod +normalQuantityAmt;
        }
      }
    }

    const outstanding_amount = this.props.orders && this.props.orders.orderDetails && this.props.orders.orderDetails.orderDetail.outstanding_amount
    cod = Math.max((outstanding_amount - cod), 0);
    return round(cod, 2)
  }

  render() {
    const id = this.props.match.params.id;
    const {
      showInvoiceModal,
      showCodModal
    } = this.state;
    return (
      <div className='pd-top-global gray-wrap mh-100'>
        {
          showCodModal &&
          <div className="flex cod-modal">
            <div className="flex cod-modal-content flex-column">
              <div className="flex flex-space-between width-100 w-600">
                Payment Confirmation
                <Cross onClick={() => this.setState({showCodModal: false})}/>
              </div>
              <p className="my-2">
              {`Please confirm \u20B9 ${this.calculateCOD()} has been collected`}
              </p>
              <Input
              label="Collected Amount"
              type="number"
              value={this.state.da_collected_amount}
              onChange={(value) => this.updateDACollectedAmount(value)}
              errorMsg={this.state.da_amount_error}
              />
              <div className="flex mt-1">
                <div
                  className={"btn btn-green-flat  btn-transparent-gray width-100 center mr-1"}
                  onClick={() => this.setState({showCodModal: false})}
                >
                  Decline
                </div>
                <div
                  className={`btn btn-green-flat width-100 center ml-1 ${this.state.da_amount_error?"btn-disabled":" btn-green"}`}
                  onClick={() => this.updateCollectedAmount()}
                >
                  Confirm
                </div>
              </div>
            </div>
          </div>
    }
    <PictureModeModal
          isOpen={showInvoiceModal}
          closePictureModeModal={() => this.closePictureModeModal()}
          id={id}
          orderNumber={this.props.location.state.orderNumber}
          type={'invoice'}
          title = {'Upload Invoice'}
          images={this.props.location.state.images}
          redirectedURL={`/order/${id}/invoice`}
          modalBody={() => {
            return <div className="center mt-neg-2"> 
              <p className="fs-16 mb-2 align-left">
                Please take an image of the invoice and make sure that the amount and items are clearly visible
              </p>
              <img src="../../images/invoiceSample.png" />
             </div>
          }}
        /> {
      !this.props.location.state ?
        <div>
            <CommonHeaderComponent title={`Products`} enableBack={true}/>
            <div className="pd-top-global fs-18 red-text center">
              Unauthorized!!!
            </div>
          </div> :
        this.props.getAllIssueReasonsStatus === symbols.STATUS_BEGIN || this.props.getOrderProductsStatus ===
        symbols.STATUS_BEGIN || this.props.saveProductIssuesStatus === symbols.STATUS_BEGIN ?
        <LoaderComponent/> :
        <div>
            <div className="order-top-header ">
              {
                this.props.orders && this.props.orders.orderDetails && this.props.orders.orderDetails.orderDetail.is_cod &&
                <div className="cod mb-1">CASH ON DELIVERY: {round(this.calculateCOD(), 2)}</div>
              }
              <div className="input-field-wrap">
                <input
                  type="text"
                  className="input-field__input search-input search-input--left-icon"
                  placeholder="Search Products"
                  onChange={(e) => this.setSearchVal(e)}
                />
                <div className="search-icon">
                  <Search className="icon-color-gray icon-fs-15"/> 
                </div>
              </div>
            </div>
            <CommonHeaderComponent 
              title={`${this.props.location.state.orderNumber} - Products`} 
              enableBack={true} 
            />
            <div className='pd-bottom-global'>
              
              <React.Fragment>
                {
                  this.state.products.map((ele) => 
                  <ProductCardComponent 
                    getDeliveredQty={(quant) => this.getDeliveredQty(quant, ele.id)}
                    key={ele.id}
                    history={this.props.history}
                    product={ele}
                    reasons={this.state.reasons}
                    allReset={this.state.allReset}
                    setIssue={this.setIssue}
                    deleteIssue={this.deleteIssue}
                    setIsOpen={(id) => this.setIsOpen(id)}
                    setClose={() => this.setClose()}
                    isOpen={this.state.isOpen[ele.id]}/>)
                }
                {
                  this.state.products.length === 0 &&
                  <div className="warning fs-14 red-text">Products not found</div>
                }
              </React.Fragment>
            </div>
            <div className={this.state.toggleDownWrapper ? 
              "order-card fixed-verify-section z-index-9 toggleDown" :
              "order-card fixed-verify-section z-index-9"}
            >
              <div className="">
                Total Items: <b>{this.state.totalItems}</b> <br/>
                Upd. Items: <b>{this.state.issueItems} </b>
              </div>
              <div
                className={"btn btn-green-flat btn-green "}
                onClick={() => this.handleOnSubmit(this.props.orders && this.props.orders.orderDetails && this.props.orders.orderDetails.orderDetail.is_cod)}
              >
                {
                  this.props.orders  && this.props.orders.orderDetails && this.props.orders.orderDetails.orderDetail.is_cod ?
                  "Proceed" :
                  "Complete Verification"
                }
              </div>
            </div>
          </div>
    } </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    getAllIssueReasonsStatus: state.statuses.getAllIssueReasons.status,
    getAllIssueReasonsError: state.statuses.getAllIssueReasons.error,
    updateDACollectedAmountStatus: state.statuses.updateDaCollectedAmount.status,
    updateDACollectedAmountError: state.statuses.updateDaCollectedAmount.errors,
    getOrderProductsStatus: state.statuses.getOrderProducts.status,
    getOrderProductError: state.statuses.getOrderProducts.error,
    orders: state.orders,
    isAssetTrackingEnabled: state.appConfig.asset_tracking_enabled || ""
  }),
  dispatch => ({
    actions: bindActionCreators({
      ...actions,
      ...compressionAction,
      fetchAppConfig
    }, dispatch),
  }),
)(OrderProductsComponent));
